import { useRecoilState } from 'recoil';
import sidebarState from '../../../stores/atoms/sidebarAtom';
import { Button } from '../../../lib/button';
import { Menu } from 'lucide-react';

export const SidebarControl = () => {
    const [open, handleStatusBar] = useRecoilState(sidebarState);

    const handleDrawer = () => {
        handleStatusBar(!open);
    };

    return (
        <Button variant="ghost" onClick={handleDrawer}>
            <Menu className="h-5 w-5" />
        </Button>
    );
};
